export default [
	{
		path: '/change_password/:token',
		lazy: async () => {
			const Module = await import('../../pages/services/admin/ChangePasswordPage');
			return { Component: Module.default };
		},
	},
];
